<div class="lightContent">
  <div class="headingPage">
    <h2>Compare Versions</h2>
  </div>
  <div class="contentPart">
    <div class="storyVersion part1">
      <div class="storyPart">
        <ul>
          
          <li>
            <label>Version 1</label>
            <div class="selectDataField">
              <select name="leftSideVersionIndex" [(ngModel)]="leftSideVersionIndex"
              (ngModelChange)="onLeftSideVersionDateChange($event)">
                <option value="current">{{getNewTypeVersionDate(currentVersion.lastModifiedDate)}} <ng-container *ngIf="getVersionModifiedByName(currentVersion) !== null && getVersionModifiedByName(currentVersion) !== undefined">[{{getVersionModifiedByName(currentVersion)}}]</ng-container> [Unpublished] </option>
                <option *ngFor="let version of versionHistory.changes; let idx = index" [value]="idx">{{getNewTypeVersionDate(version.lastModifiedDate)}} <ng-container *ngIf="getVersionModifiedByName(version) !== null && getVersionModifiedByName(version) !== undefined">[{{getVersionModifiedByName(version)}}]</ng-container></option>
              </select>
              <div class="buttons"><button class="stversion" (click)="onRestoreClicked(leftSideVersionIndex)" [disabled]="disableRestoreButton('left')">Restore</button>
              </div>
            </div>
          </li>

          <li [ngClass]="{'changeData': textDifference(rightSideVersion.mobileHeadline, leftSideVersion.mobileHeadline)}">
            <label>Headline</label>
            <div class="dataField">
              <div class="fieldBlock">
                <p [innerHtml]="leftSideVersion.mobileHeadline"></p>
              </div>
            </div>
          </li>

          <li [ngClass]="{'changeData': textDifference(rightSideVersion.summary, leftSideVersion.summary)}">
            <label>Summary</label>
            <div class="dataField">
              <div class="fieldBlock">
                <p [innerHTML]="leftSideVersion.summary"></p>
              </div>
            </div>
          </li>
        
          <li class="elementListDrag elementVersion" #autoscroll *ngIf="leftSideVersionIndex == 'current'">
            <ul class='container' #lis [dragula]="'sixth-bag'" [dragulaModel]='leftSideVersion.elements'>
              <li *ngFor="let element of leftSideVersionElements; let i = index" [ngClass]="{'tempChangeData': currentElementParagraphDifference(element)}">
                  <div #elReferenc class="element-module" [id]="element"
                    [cardId]="element" [EditMode]="false"
                    [editCardFlag]="false" [textDifferenceCase]="true"
                    [storyId]="leftSideVersion.id"
                    [storytype]="leftSideVersion.type"
                    (updateContentOnParent)="getUpadtedElementContent($event)"
                    >
                  </div>
              </li>
            </ul>
          </li>

          <li class="elementListDrag elementVersion" #autoscroll *ngIf="leftSideVersionIndex != 'current'">
            <ul class='container' #lis [dragula]="'sixth-bag'" [dragulaModel]='leftSideVersion.elements'>
              <li *ngFor="let element of leftSideVersionElements; let i = index" [ngClass]="{'tempChangeData': paragraphDifference(element)}">
                  <div #elReferenc class="element-module" [id]="element.id"
                    [cardId]="element.id" [EditMode]="false"
                    [editCardFlag]="false" [preLoadedcardData]="element" [textDifferenceCase]="true"
                    [storyId]="leftSideVersion.id"
                    [storytype]="leftSideVersion.type"
                    >
                  </div>
              </li>
            </ul>
          </li>
        
        </ul>
        <div class="clearBoth"></div>
      </div>
      <div class="tabcontent" id="meta">
        <div class="usermeta blocks marb20">
          <div class="head">Metadata</div>
          <div class="form">
            <ul class="bylineBlock">
              <li class="">
                <label>By Line</label>
                <div class="dataField">
                  <ul class="tagit ui-widget ui-widget-content ui-corner-all" id="myTags">
                    <li class="tagit-choice ui-widget-content ui-state-default ui-corner-all tagit-choice-editable" *ngFor="let author of leftSideVersion.metadata.authors">
                      <span class="tagit-label">{{author}}</span>
                      <a class="tagit-close">
                        <span class="text-icon">×</span>
                        <span class="ui-icon ui-icon-close"></span>
                      </a>
                    </li>
                    <li class="tagit-new">
                      <input class="textBox ui-widget-content ui-autocomplete-input" type="text"
                        placeholder="Add ByLine here.." [ngClass]="{'tempChangeData': arrayDifference(leftSideVersion.metadata.authors, rightSideVersion.metadata.authors)}" disabled>
                      <div>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <span class="more spImg_story">
                  more
                </span>
              </li>
            </ul>
            <ul>
              <li class="">
                <label>Agency</label>
                <div class="dataField">
                  <input class="textBox" placeholder="Add Agency here." type="text" [value]="leftSideVersion.metadata.agency" [ngClass]="{'tempChangeData': textDifference(leftSideVersion.metadata.agency, rightSideVersion.metadata.agency)}" disabled>
                </div>
              </li>
              <li class="">
                <label>
                  Section
                </label>
                <div class="dataField">
                  <input class="textBox" placeholder="Add Section here." type="text" [value]="leftSideVersion.metadata.section" [ngClass]="{'tempChangeData': textDifference(leftSideVersion.metadata.section, rightSideVersion.metadata.section)}" disabled>
                </div>
              </li>
              <li class="">
                <label>Sub-section
                </label>
                <div class="dataField">
                  <input class="textBox" placeholder="Add SubSection here." type="text" [value]="leftSideVersion.metadata.subSection" [ngClass]="{'tempChangeData': textDifference(leftSideVersion.metadata.subSection, rightSideVersion.metadata.subSection)}" disabled>
                </div>
              </li>
              <li>
                <label>Topic</label>
                <div class="dataField">
                  <ul class="tagit ui-widget ui-widget-content ui-corner-all" id="myTags">
                    <li class="tagit-choice ui-widget-content ui-state-default ui-corner-all tagit-choice-editable" *ngFor="let topic of leftSideVersion.metadata.topic">
                      <span class="tagit-label">{{topic}}</span>
                      <a class="tagit-close">
                        <span class="text-icon">×</span>
                        <span class="ui-icon ui-icon-close"></span>
                      </a>
                    </li>
                    <li class="tagit-new">
                      <input class="textBox" type="text" placeholder="Enter text to search Topics.." [ngClass]="{'tempChangeData': arrayDifference(leftSideVersion.metadata.topic, rightSideVersion.metadata.topic)}" disabled>
                      <div>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="">
                <label>Keywords</label>
                <div class="dataField">
                  <ul class="tagit ui-widget ui-widget-content ui-corner-all" id="myTags">
                    <li class="tagit-choice ui-widget-content ui-state-default ui-corner-all tagit-choice-editable" *ngFor="let keyword of leftSideVersion.metadata.keywords">
                      <span class="tagit-label">{{keyword}}</span>
                      <a class="tagit-close">
                        <span class="text-icon">×</span>
                        <span class="ui-icon ui-icon-close"></span>
                      </a>
                    </li>
                    <li class="tagit-new">
                      <input class="textBox ui-widget-content ui-autocomplete-input" type="text"
                        placeholder="Add keywords here.." [ngClass]="{'tempChangeData': arrayDifference(leftSideVersion.metadata.keywords, rightSideVersion.metadata.keywords)}" disabled>
                      <div>
                      </div>
                    </li>
                  </ul>

                </div>
              </li>
              <li>
                <label>Tags</label>
                <div class="dataField">
                  <ul class="tagit ui-widget ui-widget-content ui-corner-all" id="myTags">
                    <li class="tagit-choice ui-widget-content ui-state-default ui-corner-all tagit-choice-editable" *ngFor="let tag of leftSideVersion.metadata.tags">
                      <span class="tagit-label">{{tag}}</span>
                      <a class="tagit-close">
                        <span class="text-icon">×</span>
                        <span class="ui-icon ui-icon-close"></span>
                      </a>
                    </li>
                    
                    <li class="tagit-new">
                      <input class="textBox ui-widget-content ui-autocomplete-input" type="text"
                        placeholder="Add Tags here.." [ngClass]="{'tempChangeData': arrayDifference(leftSideVersion.metadata.tags, rightSideVersion.metadata.tags)}" disabled>
                      <div>
                      </div>
                    </li>
                  </ul>
                  <p class="moretags">
                    <a>get tags</a>
                  </p>
                </div>
              </li>
              <li>
                <label>Source</label>
                <div class="dataField">
                  <label class="radioBlock">
                    <input name="options" type="radio" [checked]="leftSideVersion.metadata.storyType === 'DIGITAL'" disabled>
                    <span class="radiomark"></span>
                    Digital
                  </label><label class="radioBlock">
                    <input name="options" type="radio" [checked]="leftSideVersion.metadata.storyType === 'PRINT'" disabled>
                    <span class="radiomark"></span>
                    Print
                  </label><label class="radioBlock">
                    <input name="options" type="radio" [checked]="leftSideVersion.metadata.storyType === 'AGENCY'" disabled>
                    <span class="radiomark"></span>
                    Agency
                  </label>
                </div>
              </li>
              <li>
                <label>Location</label>
                <div class="dataField">
                  <ul class="tagit ui-widget ui-widget-content ui-corner-all" id="myTags">
                    <li class="tagit-choice ui-widget-content ui-state-default ui-corner-all tagit-choice-editable" *ngFor="let location of leftSideVersion.metadata.location">
                      <span class="tagit-label">{{location}}</span>
                      <a class="tagit-close">
                        <span class="text-icon">×</span>
                        <span class="ui-icon ui-icon-close"></span>
                      </a>
                    </li>
                    <li class="tagit-new">
                      <input autocomplete="off" class="textBox ui-widget-content ui-autocomplete-input" type="text"
                        placeholder="Add Location here.." [ngClass]="{'tempChangeData': arrayDifference(leftSideVersion.metadata.location, rightSideVersion.metadata.location)}" disabled>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <label>Canonical URL</label>
                <div class="dataField">
                  <input class="textBox" placeholder="Add Canonical URL here" type="text" [value]="leftSideVersion.metadata.canonicalUrl" [ngClass]="{'tempChangeData': textDifference(leftSideVersion.metadata.canonicalUrl, rightSideVersion.metadata.canonicalUrl)}" disabled> 
                </div>
              </li>
              <li>
                <label>SEO URL</label>
                <div class="dataField">
                  <input class="textBox" placeholder="Add SEO URL here" type="text" [value]="leftSideVersion.metadata.seoUrl" [ngClass]="{'tempChangeData': textDifference(leftSideVersion.metadata.seoUrl, rightSideVersion.metadata.seoUrl)}" disabled>
                </div>
              </li>
              <li>
                <label>Meta Title</label>
                <div class="dataField">
                  <input class="textBox" placeholder="Add meta title here" type="text" [value]="leftSideVersion.metadata.metaTitle" [ngClass]="{'tempChangeData': textDifference(leftSideVersion.metadata.metaTitle, rightSideVersion.metadata.metaTitle)}" disabled>
                </div>
              </li>
              <li>
                <label>Meta Description</label>
                <div class="dataField">
                  <textarea cdktextareaautosize="" class="textBox" placeholder="Enter meta description here…"
                    tabindex="0" type="text" [value]="leftSideVersion.metadata.metaDescription" [ngClass]="{'tempChangeData': textDifference(leftSideVersion.metadata.metaDescription, rightSideVersion.metadata.metaDescription)}" disabled></textarea>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="storyVersion part2">
      <div class="storyPart">
        <ul>
          <li>
            <label>Version 2</label>
            <div class="selectDataField">
              <select name="rightSideVersionIndex" [(ngModel)]="rightSideVersionIndex"
                (ngModelChange)="onRightSideVersionDateChange($event)">
                <option *ngFor="let version of versionHistory.changes; let idx = index" [value]="idx">{{getNewTypeVersionDate(version.lastModifiedDate)}} <ng-container *ngIf="getVersionModifiedByName(version) !== null && getVersionModifiedByName(version) !== undefined">[{{getVersionModifiedByName(version)}}]</ng-container></option>
              </select>
              <div class="buttons"><button class="stversion" (click)="onRestoreClicked(rightSideVersionIndex)" [disabled]="disableRestoreButton('right')">Restore</button>
              </div>

            </div>
          </li>

          <li>
            <label>Headline</label>
            <div class="dataField">
              <div class="fieldBlock">
                <p [innerHtml]="rightSideVersion.mobileHeadline"></p>
              </div>
            </div>
          </li>

          <li>
            <label>Summary</label>
            <div class="dataField">
              <div class="fieldBlock">
                <p [innerHTML]="rightSideVersion.summary"></p>
              </div>
            </div>
          </li>
          <!-- <li>
            <label>Media</label>
            <div class="dataField">
              <div class="fieldBlock image">
                <img src="assets/images/image2.jpg" alt="">
              </div>
            </div>
          </li>
          <li>
            <label>Paragraph</label>
            <div class="dataField">
              <div class="fieldBlock paragraph">
                <p>Congress chief Sonia Gandhi on Tuesday said there is “a lack of clarity and cohesion” among the
                  party’s state-level leaders on policy issues as she underlined the need for redoubling efforts to
                  fight for the deprived sections.</p>
                <p>“To make this promise (of fighting for deprived sections) truly meaningful, we must also make our
                  organisation more representative of this cross-section of society,” Sonia Gandhi said during an
                  address to Congress general secretaries, secretaries, in-charges and state chiefs.</p>
                <p>She emphasised the need for discipline and unity within the party, adding that “the strengthening of
                  the organisation must override personal ambitions”.</p>
                <p>Congress chief Sonia Gandhi on Tuesday said there is “a lack of clarity and cohesion” among the
                  party’s state-level leaders on policy issues as she underlined the need for redoubling efforts to
                  fight for the deprived sections.</p>
                <p>“To make this promise (of fighting for deprived sections) truly meaningful, we must also make our
                  organisation more representative of this cross-section of society,” Sonia Gandhi said during an
                  address to Congress general secretaries, secretaries, in-charges and state chiefs.</p>
                <p>She emphasised the need for discipline and unity within the party, adding that “the strengthening of
                  the organisation must override personal ambitions”.</p>
              </div>
            </div>
          </li> -->

          <li class="elementListDrag elementVersion" #autoscroll>
            <ul class='container' #lis [dragula]="'sixth-bag'" [dragulaModel]='rightSideVersion.elements'>
              <li *ngFor="let element of rightSideVersionElements; let i = index">
                <div #elReferenc class="element-module" [id]="element.id"
                  [cardId]="element.id" [EditMode]="false"
                  [editCardFlag]="false" [preLoadedcardData]="element" [textDifferenceCase]="true"
                  [storyId]="rightSideVersion.id"
                  [storytype]="rightSideVersion.type">
                </div>
              </li>
            </ul>
          </li>

        </ul>
        <div class="clearBoth"></div>
      </div>
      <div class="tabcontent" id="meta">
        <div class="usermeta blocks marb20">
          <div class="head">Metadata</div>
          <div class="form">
            <ul class="bylineBlock">
              <li class="">
                <label>By Line</label>
                <div class="dataField">
                  <ul class="tagit ui-widget ui-widget-content ui-corner-all" id="myTags">
                    <li class="tagit-choice ui-widget-content ui-state-default ui-corner-all tagit-choice-editable" *ngFor="let author of rightSideVersion.metadata.authors">
                      <span class="tagit-label">{{author}}</span>
                      <a class="tagit-close">
                        <span class="text-icon">×</span>
                        <span class="ui-icon ui-icon-close"></span>
                      </a>
                    </li>
                    <li class="tagit-new">
                      <input class="textBox ui-widget-content ui-autocomplete-input" type="text"
                        placeholder="Add ByLine here.." disabled>
                      <div>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <span class="more spImg_story">
                  more
                </span>
              </li>
            </ul>
            <ul>
              <li class="">
                <label>Agency</label>
                <div class="dataField">
                  <input class="textBox" placeholder="Add Agency here." type="text" [value]="rightSideVersion.metadata.agency" disabled>
                </div>
              </li>
              <li class="">
                <label>
                  Section
                </label>
                <div class="dataField">
                  <input class="textBox" placeholder="Add Section here." type="text" [value]="rightSideVersion.metadata.section" disabled>
                </div>
              </li>
              <li class="">
                <label>Sub-section
                </label>
                <div class="dataField">
                  <input class="textBox" placeholder="Add SubSection here." type="text" [value]="rightSideVersion.metadata.subSection" disabled>
                </div>
              </li>
              <li>
                <label>Topic</label>
                <div class="dataField">
                  <ul class="tagit ui-widget ui-widget-content ui-corner-all" id="myTags">
                    <li class="tagit-choice ui-widget-content ui-state-default ui-corner-all tagit-choice-editable" *ngFor="let topic of rightSideVersion.metadata.topic">
                      <span class="tagit-label">{{topic}}</span>
                      <a class="tagit-close">
                        <span class="text-icon">×</span>
                        <span class="ui-icon ui-icon-close"></span>
                      </a>
                    </li>
                    <li class="tagit-new">
                      <input class="textBox" type="text" placeholder="Enter text to search Topics.." disabled>
                      <div>
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="">
                <label>Keywords</label>
                <div class="dataField">
                  <ul class="tagit ui-widget ui-widget-content ui-corner-all" id="myTags">
                    <li class="tagit-choice ui-widget-content ui-state-default ui-corner-all tagit-choice-editable" *ngFor="let keyword of rightSideVersion.metadata.keywords">
                      <span class="tagit-label">{{keyword}}</span>
                      <a class="tagit-close">
                        <span class="text-icon">×</span>
                        <span class="ui-icon ui-icon-close"></span>
                      </a>
                    </li>
                    <li class="tagit-new">
                      <input class="textBox ui-widget-content ui-autocomplete-input" type="text"
                        placeholder="Add keywords here.." disabled>
                      <div>
                      </div>
                    </li>
                  </ul>

                </div>
              </li>
              <li>
                <label>Tags</label>
                <div class="dataField">
                  <ul class="tagit ui-widget ui-widget-content ui-corner-all" id="myTags">
                    <li class="tagit-choice ui-widget-content ui-state-default ui-corner-all tagit-choice-editable" *ngFor="let tag of rightSideVersion.metadata.tags">
                      <span class="tagit-label">{{tag}}</span>
                      <a class="tagit-close">
                        <span class="text-icon">×</span>
                        <span class="ui-icon ui-icon-close"></span>
                      </a>
                    </li>
                    
                    <li class="tagit-new">
                      <input class="textBox ui-widget-content ui-autocomplete-input" type="text"
                        placeholder="Add Tags here.." disabled>
                      <div>
                      </div>
                    </li>
                  </ul>
                  <p class="moretags">
                    <a>get tags</a>
                  </p>
                </div>
              </li>
              <li>
                <label>Source</label>
                <div class="dataField">
                  <label class="radioBlock">
                    <input name="options" type="radio" [checked]="rightSideVersion.metadata.storyType === 'DIGITAL'" disabled>
                    <span class="radiomark"></span>
                    Digital
                  </label><label class="radioBlock">
                    <input name="options" type="radio" [checked]="rightSideVersion.metadata.storyType === 'PRINT'" disabled>
                    <span class="radiomark"></span>
                    Print
                  </label><label class="radioBlock">
                    <input name="options" type="radio" [checked]="rightSideVersion.metadata.storyType === 'AGENCY'" disabled>
                    <span class="radiomark"></span>
                    Agency
                  </label>
                </div>
              </li>
              <li>
                <label>Location</label>
                <div class="dataField">
                  <ul class="tagit ui-widget ui-widget-content ui-corner-all" id="myTags">
                    <li class="tagit-choice ui-widget-content ui-state-default ui-corner-all tagit-choice-editable" *ngFor="let location of rightSideVersion.metadata.location">
                      <span class="tagit-label">{{location}}</span>
                      <a class="tagit-close">
                        <span class="text-icon">×</span>
                        <span class="ui-icon ui-icon-close"></span>
                      </a>
                    </li>
                    <li class="tagit-new">
                      <input autocomplete="off" class="textBox ui-widget-content ui-autocomplete-input" type="text"
                        placeholder="Add Location here.." disabled>
                    </li>
                  </ul>
                </div>
              </li>
              <li>
                <label>Canonical URL</label>
                <div class="dataField">
                  <input class="textBox" placeholder="Add Canonical URL here" type="text" [value]="rightSideVersion.metadata.canonicalUrl" disabled> 
                </div>
              </li>
              <li>
                <label>SEO URL</label>
                <div class="dataField">
                  <input class="textBox" placeholder="Add SEO URL here" type="text" [value]="rightSideVersion.metadata.seoUrl" disabled>
                </div>
              </li>
              <li>
                <label>Meta Title</label>
                <div class="dataField">
                  <input class="textBox" placeholder="Add meta title here" type="text" [value]="rightSideVersion.metadata.metaTitle" disabled>
                </div>
              </li>
              <li>
                <label>Meta Description</label>
                <div class="dataField">
                  <textarea cdktextareaautosize="" class="textBox" placeholder="Enter meta description here…"
                    tabindex="0" type="text" [value]="rightSideVersion.metadata.metaDescription" disabled></textarea>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>